export const getRoundedDecimal = (n: number) => {
    const result = Math.round(n * 100) / 100;

    // The wallet feature is accumulating negative values, which in javascript can be accumulated as -0.
    return Object.is(result, -0) ? 0 : result;
};

export const getCurrencyExchangeRoundedDecimal = (n: number) => Math.round(n * 100000) / 100000;
